import React from 'react'
import cx from 'classnames'
import style from '../icon.module.scss'
import PropTypes from 'prop-types'
import FlagMap from '../../../../resources/assets/flags'
import { VegaIconLoading } from '../loading/IconLoading'
import { VegaIcon } from '../Icon'

const VegaIconFlag = ({ className, country = null, size = 16 }) => {
	if (country === null) {
		return <VegaIconLoading size={size} className={cx(className, style.icon)} />
	}

	const Flag = country.toLowerCase() in FlagMap ? FlagMap[country.toLowerCase()] : null

	if (Flag === null) {
		return <VegaIcon name={'flag'} size={size} className={className} />
	}

	return (
		<Flag
			className={cx(className, style.iconFlag)}
			width={size}
			height={size * (3 / 4)}
			preserveAspectRatio={'none'}
		/>
	)
}

VegaIconFlag.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Bigram ISO 3166-1 of the country */
	country: PropTypes.string,
	/** Width in px of the icon */
	size: PropTypes.number
}

export { VegaIconFlag }
